import {
  newToastNotification,
  ToastType,
} from '../../dashboard/components/ToastNotifications/toasts';

const formatErrors = (errors: unknown[]): string =>
  errors
    .map((e) =>
      typeof e === 'object' && e !== null && 'message' in e
        ? (e as { message: string }).message
        : String(e)
    )
    .join(', ');

export const createMutationErrorHandler = (fallbackMessage: string) => {
  return async (
    _: unknown,
    { queryFulfilled }: { queryFulfilled: Promise<any> }
  ) => {
    try {
      const { data } = await queryFulfilled;
      const { errors = [] } = data;
      if (errors.length) {
        newToastNotification({
          body: formatErrors(errors),
          toastType: ToastType.ERROR,
        });
      }
    } catch {
      newToastNotification({
        body: fallbackMessage,
        toastType: ToastType.ERROR,
      });
    }
  };
};

type MutationHandlerToastOptions = {
  successAutoCloseTimeout?: number;
};

export const createMutationHandler = (
  errorMessage: string,
  successMessage?: string,
  toastOptions?: MutationHandlerToastOptions
) => {
  return async (
    _: unknown,
    { queryFulfilled }: { queryFulfilled: Promise<any> }
  ) => {
    try {
      const { data } = await queryFulfilled;
      const errors = data?.errors || [];
      if (errors.length) {
        newToastNotification({
          body: formatErrors(errors),
          toastType: ToastType.ERROR,
        });
      } else if (successMessage) {
        newToastNotification({
          body: successMessage,
          toastType: ToastType.SUCCESS,
          ...(toastOptions?.successAutoCloseTimeout != null
            ? { autoCloseTimeout: toastOptions.successAutoCloseTimeout }
            : {}),
        });
      }
    } catch {
      newToastNotification({
        body: errorMessage,
        toastType: ToastType.ERROR,
      });
    }
  };
};
